import { render, staticRenderFns } from "./CrmSync.vue?vue&type=template&id=fc1714d6&scoped=true"
import script from "./CrmSync.vue?vue&type=script&lang=js"
export * from "./CrmSync.vue?vue&type=script&lang=js"
import style0 from "./CrmSync.vue?vue&type=style&index=0&id=fc1714d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1714d6",
  null
  
)

export default component.exports